<script lang="ts" setup>
import { computed } from 'vue'
import { MenuButton } from '@brighterly/lib-lumee-ui'

import type { IconName, IndicatorProps, MenuButtonLayout, MenuButtonProps } from '@brighterly/lib-lumee-ui'

import NotificationPointer from '@Atoms/NotificationPointer.vue'

defineOptions({
  name: 'HeaderNavItem',
})

const props = withDefaults(defineProps<HeaderNavItemProps>(), {
  href: undefined,
  indicator: undefined,
  selected: false,
  disabled: false,
  discount: 0,
  pointer: false,
})

const emit = defineEmits<{
  click: [MouseEvent]
}>()

const slots = defineSlots<{
  menu?: () => unknown
}>()

interface HeaderNavItemProps {
  label: string
  icon: IconName
  layout: MenuButtonLayout
  href?: string
  indicator?: IndicatorProps
  selected?: boolean
  disabled?: boolean
  discount?: number
  pointer?: boolean
}

// The DS never draws a selected item disabled: selected wins.
const buttonProps = computed<MenuButtonProps>(() => {
  const common = {
    label: props.label,
    icon: props.icon,
    layout: props.layout,
    href: props.href,
    indicator: props.indicator,
  }

  return props.selected
    ? { ...common, selected: true }
    : { ...common, disabled: props.disabled }
})

const handleClick = (event: MouseEvent): void => {
  emit('click', event)
}
</script>

<template>
  <span :class="['header-nav-item', `header-nav-item--${layout}`]">
    <MenuButton
      v-bind="buttonProps"
      class="header-nav-item__button"
      @click="handleClick"
    >
      <template
        v-if="slots.menu"
        #menu
      >
        <slot name="menu" />
      </template>
    </MenuButton>
    <span
      v-if="discount"
      class="header-nav-item__adornment header-nav-item__discount btly-text-label-s"
    >-{{ discount }}%</span>
    <span
      v-else-if="pointer"
      class="header-nav-item__adornment"
      aria-hidden="true"
    >
      <NotificationPointer view="default" />
    </span>
  </span>
</template>

<style scoped lang="scss" src="@scss/components/Molecules/HeaderNavItem.scss" />
